// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#chanhbot-root {
	margin: 0;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
		'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
		sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

#chanhbot-root .text-right {
	text-align: right;
}

#chanhbot-root .justify-between {
	justify-content: space-between;
}

#chanhbot-root .font-bold {
	font-weight: 700;
}

#chanhbot-root .text-3xl {
	font-size: 1.875rem;
	line-height: 2.25rem;
}

#chanhbot-root .font-sans {
	font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

#chanhbot-root .p-5 {
	padding: 1.25rem;
}

#chanhbot-root .w-full {
	width: 100%;
}

#chanhbot-root .flex {
	display: flex;
}

#chanhbot-root .py-20 {
	padding-bottom: 5rem;
}

#chanhbot-root .scrollbar-hide {
	-ms-overflow-style: none;
	scrollbar-width: none;
}

#chanhbot-root .overflow-x-hidden {
	overflow-x: hidden;
}

#chanhbot-root .overflow-y-auto {
	overflow-y: auto;
}

#chanhbot-root .grid-cols-1 {
	grid-template-columns: repeat(1, minmax(0, 1fr));
}

#chanhbot-root .max-w-2xl {
	max-width: 42rem;
}

#chanhbot-root .grid {
	display: grid;
}

#chanhbot-root .mx-auto {
	margin-left: auto;
	margin-right: auto;
}

#chanhbot-root .break-words {
	word-wrap: break-word;
	font-size: 15px;
}

#chanhbot-root .text-left {
	text-align: left;
}

#chanhbot-root .p-3 {
	padding: 0.45rem 0.75rem
}

#chanhbot-root .rounded-2xl {
	border-radius: 1rem;
}

#chanhbot-root .mt-3 {
	margin-top: 0.75rem;
}

#chanhbot-root .bottom-0 {
	bottom: 0px;
	position: absolute;
	left: 0;
	right: 0;
}

#chanhbot-root .bg-white {
	--tw-bg-opacity: 1;
	background-color: rgba(255, 255, 255, 1);
	background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

#chanhbot-root .rounded-xl {
	border-radius: 0.75rem;
}

#chanhbot-root .justify-end {
	justify-content: flex-end;
}

#chanhbot-root .border-0 {
	border-width: 0px;
}

#chanhbot-root button,
#chanhbot-root input,
#chanhbot-root optgroup,
#chanhbot-root select,
#chanhbot-root textarea {
	font-family: inherit;
	font-size: 100%;
	margin: 0;
	line-height: inherit;
	color: inherit;
	box-sizing: content-box;
}

#chanhbot-root .rounded-l-md {
	border-top-left-radius: 0.375rem;
	border-bottom-left-radius: 0.375rem;
}

#chanhbot-root .items-center {
	align-items: center;
}

#chanhbot-root .outline-none {
	outline: 2px solid transparent;
	outline-offset: 2px;
}

#chanhbot-root .p-4 {
	padding: 1rem;
}

#chanhbot-root .rounded-r-xl {
	border-top-right-radius: 0.75rem;
	border-bottom-right-radius: 0.75rem;
}

#chanhbot-root .w-8 {
	width: 2rem;
}

#chanhbot-root blockquote,
#chanhbot-root dl,
#chanhbot-root dd,
#chanhbot-root h1,
#chanhbot-root h2,
#chanhbot-root h3,
#chanhbot-root h4,
#chanhbot-root h5,
#chanhbot-root h6,
#chanhbot-root hr,
#chanhbot-root figure,
#chanhbot-root p,
#chanhbot-root pre {
	margin: 0;
}

#chanhbot-root .wrap-chat-btn {
	align-items: center;
	cursor: pointer;
	background: #1da64c;
	bottom: 62px;
	border-radius: 100%;
	box-shadow: rgba(0, 0, 0, 0.15) 0px 12px 24px 0px;
	display: flex;
	fill: rgb(255, 255, 255);
	height: 56px;
	justify-content: center;
	position: fixed;
	right: 32px;
	transform: scale(1);
	transition: transform 0.3s ease 0s;
	width: 56px;
	z-index: 999;
}
#chanhbot-root .wrap-chat-btn.hide {
	transform: scale(0.2);
	transition: transform 0.3s ease 0s;
	z-index: 0;
	opacity: 0;
}

#chanhbot-root .chatbot.init {
	box-shadow: 0 1px 2px 2px #f2f2f2;
	background: rgb(245, 248, 251);
	border-radius: 10px;
	box-shadow: rgba(0, 0, 0, 0.15) 0px 12px 24px 0px;
	overflow: hidden;
	position: fixed;
	bottom: 62px;
	top: initial;
	right: 32px;
	left: initial;
	width: 350px;
	height: 520px;
	z-index: 999;
	transform: scale(0);
	transform-origin: right bottom 0px;
	transition: transform 0.3s ease 0s;
}
#chanhbot-root .chatbot.active {
	background: rgb(245, 248, 251);
	border-radius: 10px;
	box-shadow: rgba(0, 0, 0, 0.15) 0px 12px 24px 0px;
	overflow: hidden;
	position: fixed;
	bottom: 62px;
	top: initial;
	right: 32px;
	left: initial;
	width: 350px;
	height: 520px;
	z-index: 999;
	transform: scale(1);
	transform-origin: right bottom 0px;
	transition: transform 0.3s ease 0s;
}
#chanhbot-root .chatbot-header {
	width: 100%;
	background-color: rgb(71, 85, 105);
	color: rgb(255, 255, 255);
	display: flex;
	fill: rgb(255, 255, 255);
	height: 56px;
	justify-content: space-between;
	align-items: center;

}
#chanhbot-root .chatbot-header-info {
	cursor: pointer;
	flex: 0 0 30px;
	display: flex;
	justify-content: flex-end;
	margin-right: 5px;
}
#chanhbot-root .chatbot-header-close-button {
	cursor: pointer;
	flex: 0 0 30px;
	display: flex;
	justify-content: flex-start;
	margin-right: 2px;
}
#chanhbot-root .chatbot-header-title {
	font-weight: 700;
	font-size: 24px;
	color: rgb(231, 246, 242);
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: calc(100% - 80px);
}

#chanhbot-root .chatbot-content {
	overflow-y: auto;
	max-height: calc(100% - 130px);
	padding: 0 10px;
}

#chanhbot-root ul {
	padding: 0;
}

#chanhbot-root .chatbot-input {
	bottom: 0px;
	position: absolute;
	left: 0;
	right: 0;
	width: 100%;
}

#chanhbot-root .chatbot-input-flex {
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	--tw-bg-opacity: 1;
	background-color: rgba(255, 255, 255, 1);
	background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

#chanhbot-root .chatbot-input-flex .text {
	outline: 2px solid transparent;
	outline-offset: 2px;
	padding: 0.75rem;
	width: 100%;
	border: 0;
	height: 40px;
	font-size: 15px;
	scrollbar-color: #1da64c #ccc;
	scrollbar-width: thin;
}

#chanhbot-root .chatbot-input-flex .button {
	border: 0;
	background: #fff;
	color: #fff;
	cursor: pointer;
	transition: 0.3s;
	border-top-left-radius: 10px;
	padding: 0 4px;
}

#chanhbot-root .chatbot-input-flex .button svg {
	width: 22px;
}
#chanhbot-root .chatbot-input-flex .button svg path {
	fill: #878887;
}
#chanhbot-root .chatbot-input-flex .button:hover {
	background: #1da64c;
}
#chanhbot-root .chatbot-input-flex .button:hover svg path {
	fill: #fff
}
#chanhbot-root .loading-search {
	width: 100px;
	position: relative;
	background-color: white;
	color: rgb(44, 51, 51);
	border-top-left-radius: 0px;
	padding: 6px 10px;
	margin-top: 15px;
}
#chanhbot-root .loading-search span {
	position: relative;
	width: 8px;
	height: 8px;
	border-radius: 5px;
	background-color: rgb(29, 166, 76);
	color: rgb(29, 166, 76);
	animation: loading-search 1s infinite linear alternate;
	animation-delay: 0.5s;
	display: inline-block;
	margin-left: 20px;
}

#chanhbot-root .loading-search span::before,
#chanhbot-root .loading-search span::after {
	content: "";
	display: inline-block;
	position: absolute;
	top: 0;
}

#chanhbot-root .loading-search span::before {
	left: -15px;
	width: 8px;
	height: 8px;
	border-radius: 5px;
	background-color: rgb(29, 166, 76);
	color: rgb(29, 166, 76);
	animation: loading-search 1s infinite alternate;
	animation-delay: 0s;
}

#chanhbot-root .loading-search span::after {
	left: 15px;
	width: 8px;
	height: 8px;
	border-radius: 5px;
	background-color: rgb(29, 166, 76);
	color: rgb(29, 166, 76);
	animation: loading-search 1s infinite alternate;
	animation-delay: 1s;
}

@keyframes loading-search {
	0% {
		background-color: rgb(29, 166, 76);
	}

	50%,
	100% {
		background-color: rgba(152, 128, 255, 0.2);
	}
}
#chanhbot-root .action-like-item {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-top: 12px;
}
#chanhbot-root .action-like-item .like {
	margin-right: 10px !important;
}
#chanhbot-root .action-like-item > p,
#chanhbot-root .action-like-item > span {
	display: flex;
	flex-direction: row;
	border: none;
	gap: 6px;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	font-weight: 450;
	font-size: inherit;
	text-align: center;
	padding: .4em 10px;
	border-radius: 1.5em;
	box-shadow: inset 0 0 0 1px #e6e7e9;
	transition: 0.5s;
}
#chanhbot-root .action-like-item>span {
	gap: 3px;
	padding: .2em 10px;
	font-size: 12px;
}
#chanhbot-root .action-like-item>span svg {
	width: 16px;
}
#chanhbot-root .action-like-item > p:hover,
#chanhbot-root .action-like-item > span:hover {
	background-color: linear-gradient(rgb(0 0 0/4%) 0 0);
}
#chanhbot-root .action-like-item .text {
	font-size: 13px;
	color: rgb(44, 51, 51);
}
#chanhbot-root .action-like-item>span .text {
	font-size: 11px;
}
#chanhbot-root .action-like-item p.active svg path,
#chanhbot-root .action-like-item span.active svg path {
	fill: rgb(29, 166, 76)
}
#chanhbot-root .star-conversation p,
#chanhbot-root .star-conversation span {
	color: rgb(44, 51, 51);
}
#chanhbot-root .star-conversation > p {
	text-align: center;
}
#chanhbot-root .star-conversation .action-like-item {
	justify-content: center;
}
#chanhbot-root .star-conversation-note {
	width: 100%;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	margin-top: 15px;
	margin-bottom: 15px;
}
#chanhbot-root .star-conversation-note textarea {
	outline: 2px solid transparent;
	outline-offset: 2px;
	padding: 0.5rem 0.75rem;
	width: 100%;
	border: 0;
	height: 22px;
	font-size: 15px;
	scrollbar-color: #ccc #ccc;
	scrollbar-width: thin;
}
#chanhbot-root .star-conversation-note button {
	background-color: #1da64c;
	color: #fff;
	cursor: pointer;
	border: 0;
	height: 36px;
	padding: 0 6px;
}
#chanhbot-root .break-words .coupon-code {
	display: inline-flex;
	flex-direction: row;
	border: none;
	gap: 6px;
	align-items: center;
	justify-content: center;
	font-weight: 450;
	font-size: 12px;
	text-align: center;
	padding: .2em 10px;
	border-radius: 1.5em;
	box-shadow: inset 0 0 0 1px #e6e7e9;
	transition: 0.5s;
	cursor: pointer;
	background-color: #1da64c;
	color: #fff;
	text-decoration: none;
}
@media only screen and (max-width: 400px) {
	#chanhbot-root .wrap-chat-btn {
		right: 20px;
	}
	#chanhbot-root .chatbot.init,
	#chanhbot-root .chatbot.active {
		width: 90%;
		right: 20px;
	}
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT;;YAEW;CACX,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,wRAAwR;AACzR;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,wCAAwC;CACxC,2DAA2D;AAC5D;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;;;;CAKC,oBAAoB;CACpB,eAAe;CACf,SAAS;CACT,oBAAoB;CACpB,cAAc;CACd,uBAAuB;AACxB;;AAEA;CACC,gCAAgC;CAChC,mCAAmC;AACpC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gCAAgC;CAChC,mCAAmC;AACpC;;AAEA;CACC,WAAW;AACZ;;AAEA;;;;;;;;;;;;;CAaC,SAAS;AACV;;AAEA;CAEC,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,YAAY;CACZ,mBAAmB;CACnB,iDAAiD;CACjD,aAAa;CACb,wBAAwB;CACxB,YAAY;CAEZ,uBAAuB;CACvB,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,kCAAkC;CAClC,WAAW;CACX,YAAY;AACb;AACA;CACC,qBAAqB;CACrB,kCAAkC;CAClC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,iCAAiC;CACjC,8BAA8B;CAC9B,mBAAmB;CACnB,iDAAiD;CACjD,gBAAgB;CAChB,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,aAAa;CACb,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,kCAAkC;CAClC,kCAAkC;AACnC;AACA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,iDAAiD;CACjD,gBAAgB;CAChB,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,aAAa;CACb,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,kCAAkC;CAClC,kCAAkC;AACnC;AACA;CACC,WAAW;CACX,kCAAkC;CAClC,yBAAyB;CACzB,aAAa;CACb,wBAAwB;CACxB,YAAY;CAEZ,8BAA8B;CAC9B,mBAAmB;;AAEpB;AACA;CACC,eAAe;CACf,cAAc;CACd,aAAa;CACb,yBAAyB;CACzB,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,cAAc;CACd,aAAa;CACb,2BAA2B;CAC3B,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,YAA2B;CAA3B,cAA2B;CAA3B,6BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,8BAA8B;CAC9B,eAAe;AAChB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,wCAAwC;CACxC,2DAA2D;AAC5D;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,gBAAgB;CAChB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,eAAe;CACf,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,SAAS;CACT,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,4BAA4B;CAC5B,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;AACA;CACC;AACD;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,sBAAsB;CACtB,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,kCAAkC;CAClC,uBAAuB;CACvB,sDAAsD;CACtD,qBAAqB;CACrB,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;;CAEC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,MAAM;AACP;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,kCAAkC;CAClC,uBAAuB;CACvB,+CAA+C;CAC/C,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,kCAAkC;CAClC,uBAAuB;CACvB,+CAA+C;CAC/C,mBAAmB;AACpB;;AAEA;CACC;EACC,kCAAkC;CACnC;;CAEA;;EAEC,0CAA0C;CAC3C;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,gBAAgB;AACjB;AACA;CACC,6BAA6B;AAC9B;AACA;;CAGC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,QAAQ;CACR,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,oBAAoB;CACpB,mCAAmC;CACnC,gBAAgB;AACjB;AACA;CACC,QAAQ;CACR,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,WAAW;AACZ;AACA;;CAEC,oDAAoD;AACrD;AACA;CACC,eAAe;CACf,sBAAsB;AACvB;AACA;CACC,eAAe;AAChB;AACA;;CAEC;AACD;AACA;;CAEC,sBAAsB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,8BAA8B;CAC9B,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,SAAS;CACT,YAAY;CACZ,cAAc;AACf;AACA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,YAAY;CACZ,QAAQ;CACR,mBAAmB;CACnB,uBAAuB;CAEvB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,oBAAoB;CACpB,mCAAmC;CACnC,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,WAAW;CACX,qBAAqB;AACtB;AACA;CACC;EACC,WAAW;CACZ;CACA;;EAEC,UAAU;EACV,WAAW;CACZ;AACD","sourcesContent":["#chanhbot-root {\n\tmargin: 0;\n\tfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n\t\t'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n\t\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\n#chanhbot-root .text-right {\n\ttext-align: right;\n}\n\n#chanhbot-root .justify-between {\n\tjustify-content: space-between;\n}\n\n#chanhbot-root .font-bold {\n\tfont-weight: 700;\n}\n\n#chanhbot-root .text-3xl {\n\tfont-size: 1.875rem;\n\tline-height: 2.25rem;\n}\n\n#chanhbot-root .font-sans {\n\tfont-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n\n#chanhbot-root .p-5 {\n\tpadding: 1.25rem;\n}\n\n#chanhbot-root .w-full {\n\twidth: 100%;\n}\n\n#chanhbot-root .flex {\n\tdisplay: flex;\n}\n\n#chanhbot-root .py-20 {\n\tpadding-bottom: 5rem;\n}\n\n#chanhbot-root .scrollbar-hide {\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n}\n\n#chanhbot-root .overflow-x-hidden {\n\toverflow-x: hidden;\n}\n\n#chanhbot-root .overflow-y-auto {\n\toverflow-y: auto;\n}\n\n#chanhbot-root .grid-cols-1 {\n\tgrid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n#chanhbot-root .max-w-2xl {\n\tmax-width: 42rem;\n}\n\n#chanhbot-root .grid {\n\tdisplay: grid;\n}\n\n#chanhbot-root .mx-auto {\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n#chanhbot-root .break-words {\n\tword-wrap: break-word;\n\tfont-size: 15px;\n}\n\n#chanhbot-root .text-left {\n\ttext-align: left;\n}\n\n#chanhbot-root .p-3 {\n\tpadding: 0.45rem 0.75rem\n}\n\n#chanhbot-root .rounded-2xl {\n\tborder-radius: 1rem;\n}\n\n#chanhbot-root .mt-3 {\n\tmargin-top: 0.75rem;\n}\n\n#chanhbot-root .bottom-0 {\n\tbottom: 0px;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n}\n\n#chanhbot-root .bg-white {\n\t--tw-bg-opacity: 1;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tbackground-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n}\n\n#chanhbot-root .rounded-xl {\n\tborder-radius: 0.75rem;\n}\n\n#chanhbot-root .justify-end {\n\tjustify-content: flex-end;\n}\n\n#chanhbot-root .border-0 {\n\tborder-width: 0px;\n}\n\n#chanhbot-root button,\n#chanhbot-root input,\n#chanhbot-root optgroup,\n#chanhbot-root select,\n#chanhbot-root textarea {\n\tfont-family: inherit;\n\tfont-size: 100%;\n\tmargin: 0;\n\tline-height: inherit;\n\tcolor: inherit;\n\tbox-sizing: content-box;\n}\n\n#chanhbot-root .rounded-l-md {\n\tborder-top-left-radius: 0.375rem;\n\tborder-bottom-left-radius: 0.375rem;\n}\n\n#chanhbot-root .items-center {\n\talign-items: center;\n}\n\n#chanhbot-root .outline-none {\n\toutline: 2px solid transparent;\n\toutline-offset: 2px;\n}\n\n#chanhbot-root .p-4 {\n\tpadding: 1rem;\n}\n\n#chanhbot-root .rounded-r-xl {\n\tborder-top-right-radius: 0.75rem;\n\tborder-bottom-right-radius: 0.75rem;\n}\n\n#chanhbot-root .w-8 {\n\twidth: 2rem;\n}\n\n#chanhbot-root blockquote,\n#chanhbot-root dl,\n#chanhbot-root dd,\n#chanhbot-root h1,\n#chanhbot-root h2,\n#chanhbot-root h3,\n#chanhbot-root h4,\n#chanhbot-root h5,\n#chanhbot-root h6,\n#chanhbot-root hr,\n#chanhbot-root figure,\n#chanhbot-root p,\n#chanhbot-root pre {\n\tmargin: 0;\n}\n\n#chanhbot-root .wrap-chat-btn {\n\t-moz-box-align: center;\n\talign-items: center;\n\tcursor: pointer;\n\tbackground: #1da64c;\n\tbottom: 62px;\n\tborder-radius: 100%;\n\tbox-shadow: rgba(0, 0, 0, 0.15) 0px 12px 24px 0px;\n\tdisplay: flex;\n\tfill: rgb(255, 255, 255);\n\theight: 56px;\n\t-moz-box-pack: center;\n\tjustify-content: center;\n\tposition: fixed;\n\tright: 32px;\n\ttransform: scale(1);\n\ttransition: transform 0.3s ease 0s;\n\twidth: 56px;\n\tz-index: 999;\n}\n#chanhbot-root .wrap-chat-btn.hide {\n\ttransform: scale(0.2);\n\ttransition: transform 0.3s ease 0s;\n\tz-index: 0;\n\topacity: 0;\n}\n\n#chanhbot-root .chatbot.init {\n\tbox-shadow: 0 1px 2px 2px #f2f2f2;\n\tbackground: rgb(245, 248, 251);\n\tborder-radius: 10px;\n\tbox-shadow: rgba(0, 0, 0, 0.15) 0px 12px 24px 0px;\n\toverflow: hidden;\n\tposition: fixed;\n\tbottom: 62px;\n\ttop: initial;\n\tright: 32px;\n\tleft: initial;\n\twidth: 350px;\n\theight: 520px;\n\tz-index: 999;\n\ttransform: scale(0);\n\ttransform-origin: right bottom 0px;\n\ttransition: transform 0.3s ease 0s;\n}\n#chanhbot-root .chatbot.active {\n\tbackground: rgb(245, 248, 251);\n\tborder-radius: 10px;\n\tbox-shadow: rgba(0, 0, 0, 0.15) 0px 12px 24px 0px;\n\toverflow: hidden;\n\tposition: fixed;\n\tbottom: 62px;\n\ttop: initial;\n\tright: 32px;\n\tleft: initial;\n\twidth: 350px;\n\theight: 520px;\n\tz-index: 999;\n\ttransform: scale(1);\n\ttransform-origin: right bottom 0px;\n\ttransition: transform 0.3s ease 0s;\n}\n#chanhbot-root .chatbot-header {\n\twidth: 100%;\n\tbackground-color: rgb(71, 85, 105);\n\tcolor: rgb(255, 255, 255);\n\tdisplay: flex;\n\tfill: rgb(255, 255, 255);\n\theight: 56px;\n\t-moz-box-pack: justify;\n\tjustify-content: space-between;\n\talign-items: center;\n\n}\n#chanhbot-root .chatbot-header-info {\n\tcursor: pointer;\n\tflex: 0 0 30px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-right: 5px;\n}\n#chanhbot-root .chatbot-header-close-button {\n\tcursor: pointer;\n\tflex: 0 0 30px;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tmargin-right: 2px;\n}\n#chanhbot-root .chatbot-header-title {\n\tfont-weight: 700;\n\tfont-size: 24px;\n\tcolor: rgb(231, 246, 242);\n\tflex: 0 0 calc(100% - 80px);\n}\n\n#chanhbot-root .chatbot-content {\n\toverflow-y: auto;\n\tmax-height: calc(100% - 130px);\n\tpadding: 0 10px;\n}\n\n#chanhbot-root ul {\n\tpadding: 0;\n}\n\n#chanhbot-root .chatbot-input {\n\tbottom: 0px;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\twidth: 100%;\n}\n\n#chanhbot-root .chatbot-input-flex {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\t--tw-bg-opacity: 1;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tbackground-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n}\n\n#chanhbot-root .chatbot-input-flex .text {\n\toutline: 2px solid transparent;\n\toutline-offset: 2px;\n\tpadding: 0.75rem;\n\twidth: 100%;\n\tborder: 0;\n\theight: 40px;\n\tfont-size: 15px;\n\tscrollbar-color: #1da64c #ccc;\n\tscrollbar-width: thin;\n}\n\n#chanhbot-root .chatbot-input-flex .button {\n\tborder: 0;\n\tbackground: #fff;\n\tcolor: #fff;\n\tcursor: pointer;\n\ttransition: 0.3s;\n\tborder-top-left-radius: 10px;\n\tpadding: 0 4px;\n}\n\n#chanhbot-root .chatbot-input-flex .button svg {\n\twidth: 22px;\n}\n#chanhbot-root .chatbot-input-flex .button svg path {\n\tfill: #878887;\n}\n#chanhbot-root .chatbot-input-flex .button:hover {\n\tbackground: #1da64c;\n}\n#chanhbot-root .chatbot-input-flex .button:hover svg path {\n\tfill: #fff\n}\n#chanhbot-root .loading-search {\n\twidth: 100px;\n\tposition: relative;\n\tbackground-color: white;\n\tcolor: rgb(44, 51, 51);\n\tborder-top-left-radius: 0px;\n\tpadding: 6px 10px;\n\tmargin-top: 15px;\n}\n#chanhbot-root .loading-search span {\n\tposition: relative;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 5px;\n\tbackground-color: rgb(29, 166, 76);\n\tcolor: rgb(29, 166, 76);\n\tanimation: loading-search 1s infinite linear alternate;\n\tanimation-delay: 0.5s;\n\tdisplay: inline-block;\n\tmargin-left: 20px;\n}\n\n#chanhbot-root .loading-search span::before,\n#chanhbot-root .loading-search span::after {\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\ttop: 0;\n}\n\n#chanhbot-root .loading-search span::before {\n\tleft: -15px;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 5px;\n\tbackground-color: rgb(29, 166, 76);\n\tcolor: rgb(29, 166, 76);\n\tanimation: loading-search 1s infinite alternate;\n\tanimation-delay: 0s;\n}\n\n#chanhbot-root .loading-search span::after {\n\tleft: 15px;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 5px;\n\tbackground-color: rgb(29, 166, 76);\n\tcolor: rgb(29, 166, 76);\n\tanimation: loading-search 1s infinite alternate;\n\tanimation-delay: 1s;\n}\n\n@keyframes loading-search {\n\t0% {\n\t\tbackground-color: rgb(29, 166, 76);\n\t}\n\n\t50%,\n\t100% {\n\t\tbackground-color: rgba(152, 128, 255, 0.2);\n\t}\n}\n#chanhbot-root .action-like-item {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tmargin-top: 12px;\n}\n#chanhbot-root .action-like-item .like {\n\tmargin-right: 10px !important;\n}\n#chanhbot-root .action-like-item > p,\n#chanhbot-root .action-like-item > span {\n\tcursor: pointer;\n\tdisplay: flex;\n\tflex-direction: row;\n\tborder: none;\n\tgap: 6px;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\tfont-weight: 450;\n\tfont-size: inherit;\n\ttext-align: center;\n\tpadding: .4em 10px;\n\tborder-radius: 1.5em;\n\tbox-shadow: inset 0 0 0 1px #e6e7e9;\n\ttransition: 0.5s;\n}\n#chanhbot-root .action-like-item>span {\n\tgap: 3px;\n\tpadding: .2em 10px;\n\tfont-size: 12px;\n}\n#chanhbot-root .action-like-item>span svg {\n\twidth: 16px;\n}\n#chanhbot-root .action-like-item > p:hover,\n#chanhbot-root .action-like-item > span:hover {\n\tbackground-color: linear-gradient(rgb(0 0 0/4%) 0 0);\n}\n#chanhbot-root .action-like-item .text {\n\tfont-size: 13px;\n\tcolor: rgb(44, 51, 51);\n}\n#chanhbot-root .action-like-item>span .text {\n\tfont-size: 11px;\n}\n#chanhbot-root .action-like-item p.active svg path,\n#chanhbot-root .action-like-item span.active svg path {\n\tfill: rgb(29, 166, 76)\n}\n#chanhbot-root .star-conversation p,\n#chanhbot-root .star-conversation span {\n\tcolor: rgb(44, 51, 51);\n}\n#chanhbot-root .star-conversation > p {\n\ttext-align: center;\n}\n#chanhbot-root .star-conversation .action-like-item {\n\tjustify-content: center;\n}\n#chanhbot-root .star-conversation-note {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: space-between;\n\tmargin-top: 15px;\n\tmargin-bottom: 15px;\n}\n#chanhbot-root .star-conversation-note textarea {\n\toutline: 2px solid transparent;\n\toutline-offset: 2px;\n\tpadding: 0.5rem 0.75rem;\n\twidth: 100%;\n\tborder: 0;\n\theight: 22px;\n\tfont-size: 15px;\n\tscrollbar-color: #ccc #ccc;\n\tscrollbar-width: thin;\n}\n#chanhbot-root .star-conversation-note button {\n\tbackground-color: #1da64c;\n\tcolor: #fff;\n\tcursor: pointer;\n\tborder: 0;\n\theight: 36px;\n\tpadding: 0 6px;\n}\n#chanhbot-root .break-words .coupon-code {\n\tdisplay: inline-flex;\n\tflex-direction: row;\n\tborder: none;\n\tgap: 6px;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\tfont-weight: 450;\n\tfont-size: 12px;\n\ttext-align: center;\n\tpadding: .2em 10px;\n\tborder-radius: 1.5em;\n\tbox-shadow: inset 0 0 0 1px #e6e7e9;\n\ttransition: 0.5s;\n\tcursor: pointer;\n\tbackground-color: #1da64c;\n\tcolor: #fff;\n\ttext-decoration: none;\n}\n@media only screen and (max-width: 400px) {\n\t#chanhbot-root .wrap-chat-btn {\n\t\tright: 20px;\n\t}\n\t#chanhbot-root .chatbot.init,\n\t#chanhbot-root .chatbot.active {\n\t\twidth: 90%;\n\t\tright: 20px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
